import { render, staticRenderFns } from "./EventDesc.vue?vue&type=template&id=35487bfc&scoped=true"
import script from "./EventDesc.vue?vue&type=script&lang=js"
export * from "./EventDesc.vue?vue&type=script&lang=js"
import style0 from "./EventDesc.vue?vue&type=style&index=0&id=35487bfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35487bfc",
  null
  
)

export default component.exports